import { EParcelType } from "dto/EParcelType";

export function getDefaultParcelType(type?: number) {
  console.log("Default parcel type", type);
  if (!type) return null;

  if ((type & EParcelType.EDelivery) !== 0) return EParcelType.EDelivery;

  if ((type & EParcelType.EncryptedEDelivery) !== 0)
    return EParcelType.EncryptedEDelivery;

  if ((type & EParcelType.ExternalEDelivery) !== 0)
    return EParcelType.ExternalEDelivery;

  if ((type & EParcelType.NotaEncrypted) !== 0)
    return EParcelType.NotaEncrypted;

  if ((type & EParcelType.Email) !== 0) return EParcelType.Email;

  if ((type & EParcelType.CourtPortalWriting) !== 0)
    return EParcelType.CourtPortalWriting;

  if ((type & EParcelType.Puh) !== 0) return EParcelType.Puh;

  if ((type & EParcelType.Epuap) !== 0) return EParcelType.Epuap;

  if ((type & EParcelType.TraditionalLetter) !== 0) {
    return EParcelType.TraditionalLetter;
  }

  return null;
}
